import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { CollectionMoleculeReatom } from "../store/index.reatom"

export const useNftWithFloorPrice = () => {
  const { nftWithFloorPriceQueryParamsAtom } = useMolecule(
    CollectionMoleculeReatom,
  )
  const queryParams = nftWithFloorPriceQueryParamsAtom()
  const { data } = useSuspenseQuery(queryParams)

  return data?.nftWithFloorPrice
}
